import React from 'react';
import BigBGLogo from '../assets/images/BigBGLogo.png';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  height: 75vh;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  position: relative;
  padding: 0 20px;

  @media (max-width: 768px) {
    height: 85vh;
    justify-content: center;
  }

  @media (max-width: 480px) {
    height: 85vh;
    padding: 20px 10px;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 500;
  gap: 30px;

  @media (max-width: 768px) {
    gap: 20px;
  }

  @media (max-width: 480px) {
    gap: 15px;
  }
`;

const Title = styled.h1`
  font-size: 28px;

  @media (max-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

const Desc = styled.p`
  font-size: 24px;

  @media (max-width: 768px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
    text-align: center;
  }
`;

const Image = styled.img`
  width: 80%;

  @media (max-width: 768px) {
    width: 90%;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const UnauthorizedMessage: React.FC = () => {
  return (
    <Container>
      <TitleContainer>
        <Title>권한이 없습니다.</Title>
        <Desc>이 페이지에 접근할 수 있는 권한이 없습니다.</Desc>
      </TitleContainer>
      <Image src={BigBGLogo} alt="loginLogo" />
    </Container>
  );
};

export default UnauthorizedMessage;
